const o = "left", O = "right", t = "top", T = "bottom", I = /* @__PURE__ */ new Set([t, T]), N = {
  left: o,
  right: O,
  top: t,
  bottom: T
};
export {
  N as default,
  I as verticalOrientationsSet
};
